/*
  Configuración de la API.

  `??` y no `||` a propósito: así una cadena **vacía** es un valor válido y no
  cae al respaldo. Compilando con `REACT_APP_API_URL=` todas las llamadas salen
  relativas (`/api/…`) y van al mismo origen que sirvió la página.

  Eso es lo que permite enseñar la app por un túnel sin volver a compilar cada
  vez que cambia la dirección: el build deja de saber a qué host habla. Con
  `||`, la cadena vacía era falsa, se usaba `localhost:8000` — y en el teléfono
  de quien abre el enlace, «localhost» es su propio teléfono.
*/
export const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

// ─────────────────────────────────────────────────────────────
// Datos de contacto de marca
// Centralizados aquí en el rebranding a VONDI (Fase 0) para que el
// cambio de dominio sea una sola edición en vez de buscar por el código.
//
// TODO-VONDI: siguen apuntando al dominio viejo miembrospremier.com.
// Actualizar a vondi.mx cuando (1) exista el dominio y (2) existan los
// buzones de correo. NO cambiar antes: romperia el contacto de soporte.
// TODO-VONDI: la cuenta de Instagram sigue siendo @miembrospremier.
// Cambiar solo cuando exista/se renombre la cuenta real de VONDI.
// ─────────────────────────────────────────────────────────────
export const CONTACT_EMAIL  = 'contacto@miembrospremier.com';
export const INSTAGRAM_URL  = 'https://www.instagram.com/miembrospremier';

// Configuración de Stripe
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_51JPBNOIXb6RBKifgTnygkWBpPHR9huKVhWIw3j3VNGAWr1K51qflMoTY7Pafl2pRdLYahonf0b6KPZlMFU0CWuGj00cOhBUtq8';

export const API_ENDPOINTS = {
  STORES: `${API_BASE_URL}/api/stores`,
  BENEFITS: `${API_BASE_URL}/api/benefits`,
  // Estado de desbloqueo del usuario en el tier gratuito (Módulo 1)
  BENEFITS_STATE: `${API_BASE_URL}/api/me/benefits-state`,
  BENEFIT_UNLOCK: (id) => `${API_BASE_URL}/api/benefits/${id}/unlock`,
  NOTIFICATIONS: `${API_BASE_URL}/api/notifications`,
  USER: `${API_BASE_URL}/api/user`,
  MEMBERSHIP: `${API_BASE_URL}/api/membership/plan`,
  REGISTER: `${API_BASE_URL}/api/register`,
  LOGIN: `${API_BASE_URL}/api/login`,
  FORGOT_PASSWORD: `${API_BASE_URL}/api/auth/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL}/api/auth/reset-password`,
  // Verificación de correo por código (anti-abuso del beneficio gratis)
  EMAIL_VERIFICATION_CODE: `${API_BASE_URL}/api/email/verification-code`,
  EMAIL_VERIFY: `${API_BASE_URL}/api/email/verify`,
  PAYMENT_INTENT: `${API_BASE_URL}/api/payment-intent`,
  SUBSCRIPTION_CREATE: `${API_BASE_URL}/api/subscription/create`,
  SUBSCRIPTION_PRICE: `${API_BASE_URL}/api/subscription/price`,
  SUBSCRIPTION: `${API_BASE_URL}/api/subscription`,
  SUBSCRIPTION_REFRESH: `${API_BASE_URL}/api/subscription/refresh`,
  SUBSCRIPTION_CONFIRM_PAYMENT: `${API_BASE_URL}/api/subscription/confirm-payment`,
  SUBSCRIPTION_CANCEL: `${API_BASE_URL}/api/subscription/cancel`,
  // Landing config
  LANDING_CONFIG: `${API_BASE_URL}/api/landing-config`,
  ADMIN_LANDING_CONFIG: `${API_BASE_URL}/api/admin/landing-config`,
  // Admin endpoints
  ADMIN_STORES: `${API_BASE_URL}/api/admin/stores`,
  ADMIN_FEATURED_STORES: `${API_BASE_URL}/api/admin/featured-stores`,
  ADMIN_BRANDS: `${API_BASE_URL}/api/admin/brands`,
  ADMIN_PROMOTIONS: `${API_BASE_URL}/api/admin/promotions`,
  ADMIN_ADS: `${API_BASE_URL}/api/admin/ads`,
  ADMIN_SUBSCRIBERS: `${API_BASE_URL}/api/admin/subscribers`,
  ADMIN_QR_REDEMPTIONS: `${API_BASE_URL}/api/admin/qr-redemptions`,
  ADMIN_OUTLET_MAP: `${API_BASE_URL}/api/admin/outlet-map`,
};

